// Generated by CoffeeScript 2.7.0
var OPERATIONS, TagsList;

import TagsListContainer from 'trunks/vue/admin/compositions/tags_groups/tags_list_container.js';

import MoveTagModal from 'trunks/vue/admin/compositions/tags_groups/tag_modals/move_tag_modal.js';

import EditTagModal from 'trunks/vue/admin/compositions/tags_groups/tag_modals/edit_tag_modal.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import ResponsiveItem from 'trunks/vue/admin/components/responsive_item.js';

OPERATIONS = [
  {
    type: 'view'
  },
  {
    type: 'move'
  },
  {
    type: 'edit'
  },
  {
    type: 'delete'
  }
];

export default TagsList = Vue.extend({
  components: {
    'tags-list-container': TagsListContainer,
    'responsive-item': ResponsiveItem
  },
  props: {
    selectedTagsGroupId: {
      type: String
    },
    activeTab: {
      type: String
    }
  },
  data: function() {
    return {
      tagUrl: Skylark.Helpers.UrlHelper.namespaceUrlFor("/receipts/tags"),
      doRequestUrl: `/admin/tag_groups/${this.activeTab}`,
      selectedTagsGroup: {},
      tagsGroupOptions: [],
      tags: [],
      operations: OPERATIONS
    };
  },
  template: `<tags-list-container :selectedTagsGroupName='selectedTagsGroup.name'>
  <template slot="content">
    <div class="list-head" v-if="tagsGroupOptions.length">
      <button class="text-btn btn-primary" @click="openAddTagModal">
        <i class="slp-plus-circle"></i>
        <span>新增标签</span>
      </button>
    </div>
    <div class="list-body" v-if="showTagsList">
      <template v-for="tag in tags">
        <responsive-item :headers="headerOption"
                         :item="tag"
                         :operations="operations">
          <template slot="cellInfo" slot-scope="{ attr }">
            <a v-if="attr == 'tag_url'"
               class="tag-url"
               @click="goToUrl(tag)"
               target="_blank">{{ _getUrl(tag) }}</a>
            <span :class="attr" v-else>{{ tag[attr] }}</span>
          </template>
          <template slot="operations">
            <a class="text-btn btn btn-primary mr-1" :href='_getTargetUrl(tag)' :disabled="tag.taggings_count == 0">查看</a>
            <button class="text-btn btn-primary mr-1" @click="openMoveTagModal(tag)">移动</button>
            <button class="text-btn btn-primary mr-1" @click="openEditTagModal(tag)">修改</button>
            <button class="text-btn btn-danger mr-1" @click="deleteTag(tag)" :disabled="_deleteButtonDisabled(tag)">删除</button>
          </template>
        </responsive-item>
      </template>
    </div>
    <div class="no-data" v-else>暂无数据</div>
  </template>
</tags-list-container>`,
  created: function() {
    return Turbolinks.clearCache();
  },
  watch: {
    doRequestUrl: {
      handler: function() {
        if (this.selectedTagsGroupId) {
          return this.doRequest();
        }
      },
      immediate: true
    }
  },
  computed: {
    recieptAction: function() {
      return this.activeTab === 'receipt';
    },
    showTagsList: function() {
      var ref;
      return (ref = this.tags) != null ? ref.length : void 0;
    },
    headerOption: function() {
      if (this.activeTab === 'receipt') {
        return {
          name: "标签名称",
          taggings_count: "消息数量",
          tag_url: "标签地址"
        };
      } else {
        return {
          name: "标签名称",
          taggings_count: "成员数量"
        };
      }
    }
  },
  methods: {
    doRequest: function() {
      return Skylark.Libs.Ajax.get(this.doRequestUrl, {
        responseType: 'json',
        success: (data) => {
          this.tagsGroupOptions = data;
          return this._getSelectedTagsGroup();
        }
      });
    },
    openMoveTagModal: function(tag) {
      return new MoveTagModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('move-tag-modal'),
        propsData: {
          rejectTagGroup: this.selectedTagsGroup,
          doRequestUrl: this.doRequestUrl,
          callback: (selectedTagsGroupId) => {
            return this.moveTag(tag, selectedTagsGroupId);
          }
        }
      });
    },
    moveTag: function(tag, selectedTagsGroupId) {
      return Skylark.Libs.Ajax.patch(`/admin/tags/${tag.id}/move`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          target_id: selectedTagsGroupId
        },
        success: () => {
          Skylark.Bridge.newAlertify('移动标签成功', {
            type: 'success'
          });
          return this.tags = _.reject(this.tags, function(item) {
            return item.id === tag.id;
          });
        },
        error: function() {
          return Skylark.Bridge.newAlertify('移动标签失败', {
            type: 'error'
          });
        }
      });
    },
    openEditTagModal: function(tag) {
      return new EditTagModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('edit-tag-modal'),
        propsData: {
          title: '编辑标签',
          initialTagName: tag.name,
          callback: (tagName) => {
            return this.editTagFunc(tag, tagName);
          }
        }
      });
    },
    editTagFunc: function(tag, tagName) {
      return Skylark.Libs.Ajax.patch(`/admin/tags/${tag.id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          tag: {
            name: tagName
          }
        },
        success: () => {
          _.each(this.selectedTagsGroup.tags, function(item) {
            if (item.id === tag.id) {
              return item.name = tagName;
            }
          });
          return Skylark.Bridge.newAlertify('编辑标签成功', {
            type: 'success'
          });
        },
        error: function() {
          return Skylark.Bridge.newAlertify('编辑标签失败，请重试', {
            type: 'error'
          });
        }
      });
    },
    openAddTagModal: function() {
      return new EditTagModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add-tag-modal'),
        propsData: {
          title: '新增标签',
          callback: (tagName) => {
            return this.addTagFunc(tagName);
          }
        }
      });
    },
    addTagFunc: function(tagName) {
      return Skylark.Libs.Ajax.post(`/admin/tag_groups/${this.selectedTagsGroup.id}/tags?type=${this.activeTab}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          tag: {
            name: tagName
          }
        },
        success: (data) => {
          this.selectedTagsGroup.tags.push(data);
          return Skylark.Bridge.newAlertify('添加标签成功', {
            type: 'success'
          });
        },
        error: function() {
          return Skylark.Bridge.newAlertify('添加标签失败，请重试', {
            type: 'error'
          });
        }
      });
    },
    deleteTag: function(tag) {
      return newConfirm({
        icon: "<i class='slp-warning-circle-o'></i>",
        title: '是否删除此标签',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'danger'
      }).$on('ensureClicked', () => {
        return Skylark.Libs.Ajax.delete(`/admin/tags/${tag.id}`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: () => {
            Skylark.Bridge.newAlertify('删除标签成功', {
              type: 'success'
            });
            return this.tags = _.reject(this.tags, function(item) {
              return item.id === tag.id;
            });
          },
          error: function() {
            return Skylark.Bridge.newAlertify('删除标签分组失败', {
              type: 'error'
            });
          }
        });
      });
    },
    _deleteButtonDisabled: function(tag) {
      if (this.activeTab === 'receipt') {
        return tag.taggings_count !== 0;
      }
    },
    goToUrl: function(tag) {
      return window.open(`${this.tagUrl}/${tag.id}`);
    },
    _getUrl: function(tag) {
      return `${this.tagUrl}/${tag.id}`;
    },
    _getSelectedTagsGroup: function() {
      this.selectedTagsGroup = _.find(this.tagsGroupOptions, (tagsGroupOption) => {
        return tagsGroupOption.id === parseInt(this.selectedTagsGroupId);
      });
      return this.tags = this.selectedTagsGroup.tags;
    },
    _getTargetUrl: function(tag) {
      return `/admin/tags/${tag.id}/taggables`;
    }
  }
});
